module.exports = __webpack_public_path__ + "img/border4.b9a5c46f.png";